import { render, staticRenderFns } from "./createEventoSite.vue?vue&type=template&id=c88b62d2&scoped=true&"
import script from "./createEventoSite.vue?vue&type=script&lang=js&"
export * from "./createEventoSite.vue?vue&type=script&lang=js&"
import style0 from "./createEventoSite.vue?vue&type=style&index=0&id=c88b62d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88b62d2",
  null
  
)

export default component.exports